import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getActiveFolder, getViewOptions } from './options';
import { getState } from './state';
import { getBucketStreamId } from '../../utils';
import { getActiveDrawerStreamId, getLatestTs } from './drawer';
import { GROUP_FEED_BUCKET, USER_FEED_BUCKET } from '../../constants';
export function getActiveBucket(state) {
    var _getViewOptions_activeBucket;
    const bucketId = (_getViewOptions_activeBucket = getViewOptions(state).activeBucket) === null || _getViewOptions_activeBucket === void 0 ? void 0 : _getViewOptions_activeBucket.bucket;
    if (bucketId && [
        USER_FEED_BUCKET,
        GROUP_FEED_BUCKET
    ].includes(bucketId)) {
        return {
            bucket: bucketId,
            ts: getLatestTs(state)
        };
    }
    return getBucket(state, bucketId);
}
export function getActiveBucketHeader(state) {
    var _getState_bucketData_bucket_bucket;
    const bucket = getViewOptions(state).activeBucket;
    if (!bucket) {
        return undefined;
    }
    return (_getState_bucketData_bucket_bucket = getState(state).bucketData[bucket.bucket]) === null || _getState_bucketData_bucket_bucket === void 0 ? void 0 : _getState_bucketData_bucket_bucket.header;
}
export function getActiveBucketFilters(state) {
    var _getViewOptions, _getState_bucketData_bucket_bucket;
    const bucket = (_getViewOptions = getViewOptions(state)) === null || _getViewOptions === void 0 ? void 0 : _getViewOptions.activeBucket;
    if (!bucket) {
        return [];
    }
    var _getState_bucketData_bucket_bucket_filters;
    return (_getState_bucketData_bucket_bucket_filters = (_getState_bucketData_bucket_bucket = getState(state).bucketData[bucket.bucket]) === null || _getState_bucketData_bucket_bucket === void 0 ? void 0 : _getState_bucketData_bucket_bucket.filters) !== null && _getState_bucketData_bucket_bucket_filters !== void 0 ? _getState_bucketData_bucket_bucket_filters : [];
}
export function getActiveBucketHasFilters(state) {
    return getActiveBucketFilters(state).length > 0;
}
export function getActiveBucketStreamParams(state) {
    const bucket = getViewOptions(state).activeBucket;
    if (!bucket) {
        return {
            bucket: ''
        };
    }
    return {
        folder: getActiveFolder(state),
        bucket: bucket.bucket,
        filterId: bucket.filterId
    };
}
export function getActiveBucketStreamId(state) {
    if (!getViewOptions(state).activeBucket) {
        return undefined;
    }
    return getBucketStreamId(getActiveBucketStreamParams(state));
}
export function getDrawerStreamEntry(state, bucket) {
    const streamId = getActiveDrawerStreamId(state);
    if (bucket && streamId) {
        const items = streamSelectors.getItems(state, streamId);
        return items.find((item)=>{
            var _item_bucket;
            return ((_item_bucket = item.bucket) === null || _item_bucket === void 0 ? void 0 : _item_bucket.bucket) === bucket;
        });
    }
    return undefined;
}
export function getBucket(state, bucket) {
    var _getDrawerStreamEntry;
    return (_getDrawerStreamEntry = getDrawerStreamEntry(state, bucket)) === null || _getDrawerStreamEntry === void 0 ? void 0 : _getDrawerStreamEntry.bucket;
}
export function getActiveBucketFilterId(state) {
    const bucket = getViewOptions(state).activeBucket;
    return bucket === null || bucket === void 0 ? void 0 : bucket.filterId;
}
export function isAllFeedBucket(state) {
    var _getViewOptions_activeBucket;
    const bucket = (_getViewOptions_activeBucket = getViewOptions(state).activeBucket) === null || _getViewOptions_activeBucket === void 0 ? void 0 : _getViewOptions_activeBucket.bucket;
    return bucket === USER_FEED_BUCKET || bucket === GROUP_FEED_BUCKET;
}
